import PermissionManagement from '../components/PermissionManagement/PermissionManagement';
import PageLayout from '../components/pageLayout';

function PermissionManagementPage() {
    // console.log("Rendering PermissionManagementPage");
    return (
        <PageLayout children={<PermissionManagement />} />
    );
}

export default PermissionManagementPage;
